import moment from 'moment';

import { Http } from '../../../support';

export const initialState = {
  busy: false,
  retry: false,
  data: [],
  selectedTab: 'todo',
  filters: {
    to: moment().format('YYYY-MM-DD'),
    from: moment().subtract(1, 'month').format('YYYY-MM-DD'),
    search: '',
  },
  selectedRows: [],
  selectedRowKeys: [],
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
  },
};

const setFilters = (store, data) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.tickets.list.filters = {
      ...state.modulo.retenciones_masivas.tickets.list.filters,
      ...data,
    };
  });
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.tickets.list = {
      ...state.modulo.retenciones_masivas.tickets.list,
      ...data,
    };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.tickets.list.data = {
      ...state.modulo.retenciones_masivas.tickets.list.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    const { filters = {}, pagination = {} } = params || {};

    state.modulo.retenciones_masivas.tickets.list = {
      ...state.modulo.retenciones_masivas.tickets.list,
      busy: true,
      filters: {
        ...state.modulo.retenciones_masivas.tickets.list.filters,
        ...filters,
      },
      pagination: {
        ...state.modulo.retenciones_masivas.tickets.list.pagination,
        ...pagination,
      },
    };
  });

  try {
    const { filters, pagination } = store.state.modulo.retenciones_masivas.tickets.list;

    const body = {
      ...filters,
      ...params.filters,
      ...pagination,
      ...params.pagination,
      include: 'errors',
    };

    const response = await Http.get(`/api/timbrado-masivo/retenciones/tickets`, { params: body });

    store.setState((state) => {
      state.modulo.retenciones_masivas.tickets.list = {
        ...state.modulo.retenciones_masivas.tickets.list,
        busy: false,
        data: response.data,
        pagination: {
          ...state.modulo.retenciones_masivas.tickets.list.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.retenciones_masivas.tickets.list.busy = false;
      state.modulo.retenciones_masivas.tickets.list.error = error.data || error;
    });
  }
};

const retryStamping = async (store, params) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.tickets.list.retry = true;
  });

  const body = {
    tickets: params.tickets,
  };

  try {
    const response = await Http.post(`api/timbrado-masivo/retenciones/tickets/retry`, body);

    window.ToastManager.show({
      variant: 'success',
      title: 'Reintento de timbrado.',
      message: response.message ?? 'Se está reservando los recursos para procesar tu solicitud.',
    });

    store.setState((state) => {
      state.modulo.retenciones_masivas.tickets.list.retry = false;
      state.modulo.retenciones_masivas.tickets.list.result = response;
    });
  } catch (error) {
    window.ToastManager.show({
      variant: 'error',
      title: 'Error',
      message: error.data?.message ?? error.message ?? 'No se pudo procesar tu solicitud.',
    });

    store.setState((state) => {
      state.modulo.retenciones_masivas.tickets.list.busy = false;
      state.modulo.retenciones_masivas.tickets.list.error = error.data || error;
    });
  }
};

const download = async (store, params) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.tickets.list.busy = true;
  });

  try {
    const response = await Http.get(`${window.BONJOUR_URL}/api/timbrado-masivo/retenciones/tickets`, { params });

    window.ToastManager.show({
      variant: 'success',
      title: 'Descarga de tickets.',
    });

    window.location = response.data.link;

    store.setState((state) => {
      state.modulo.retenciones_masivas.tickets.list.busy = false;
      state.modulo.retenciones_masivas.tickets.list.result = response;
    });
  } catch (error) {
    window.ToastManager.show({
      variant: 'error',
      title: 'Error',
      message: error.data?.message ?? error.message ?? 'No se pudo procesar tu solicitud.',
    });

    store.setState((state) => {
      state.modulo.retenciones_masivas.tickets.list.busy = false;
      state.modulo.retenciones_masivas.tickets.list.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.modulo.retenciones_masivas.tickets.list = {
      ...initialState,
    };
  });
};

const RetencionesMasivasTicketsListStore = {
  state: () => initialState,
  actions: {
    change,
    download,
    setFilters,
    retryStamping,
    setSelectedRows,
    paginate,
    reset,
  },
};

export default RetencionesMasivasTicketsListStore;
